import { isAxiosError } from "axios"

/**
 * The message of a Conductor or engine error body, `{"Err msg": "..."}`,
 * whether axios parsed it into an object or it arrived as JSON text.
 * Returns null for any other body (a report, a CSV, an empty answer).
 */
export const errMsgOf = (body: unknown): string | null => {
  let value = body
  if (typeof value === "string") {
    const text = value.trim()
    if (!text.startsWith("{")) return null
    try {
      value = JSON.parse(text)
    } catch {
      return null
    }
  }
  if (!value || typeof value !== "object" || Array.isArray(value)) return null
  const msg = (value as Record<string, unknown>)["Err msg"]
  return typeof msg === "string" ? msg : null
}

/**
 * The server's message for a failed request: its `{"Err msg"}`, or a body of
 * plain text; otherwise the error's own message (for a request that never
 * got an answer, or an Error made from a 200 answer's message).
 */
export const failureOf = (e: unknown): string => {
  if (isAxiosError(e)) {
    const body: unknown = e.response?.data
    const msg = errMsgOf(body)
    if (msg !== null) return msg
    if (typeof body === "string" && body.trim() !== "") return body.trim()
    if (e.message) return e.message
  }
  return e instanceof Error ? e.message : String(e)
}
